import { createAction } from 'typesafe-actions';
import { IPumpingStationFilterSize } from '../../../../@types/model/masterData/pumpingStation/filterSize';

export default class MasterDataPumpingStationFilterSizeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_FILTER_SIZES', resolve => (pumps : Array<IPumpingStationFilterSize>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_FILTER_SIZES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}